import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminSidebar } from '@src/components/Admin/AdminSidebar';
import { AuthRequired } from '@src/components/AuthRequired';
import { LogoutModal } from '@src/components/LogoutModal';
import { AdminContextProvider } from '@src/contexts/AdminContextProvider';
import classNames from 'classnames';
import { ADMIN_PERMISSIONS, LoginActivityMonitor } from 'pe-core-frontend';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styles from './AdminLayout.module.scss';
export const AdminLayout = () => {
    const location = useLocation();
    const isClaimsPage = location.pathname.includes('/claims/payments');
    useEffect(() => {
        const html = document.querySelector('html');
        if (isClaimsPage && html) {
            // claims processing page has independent scrolling for each section,
            // so we need to disable the main page scrolling
            html.style.overflow = 'hidden';
        }
        return () => {
            if (html) {
                html.style.overflow = '';
            }
        };
    }, [isClaimsPage]);
    return (_jsx(AdminContextProvider, { children: _jsxs("div", { className: classNames('admin-page', styles.container), children: [_jsx(AdminSidebar, {}), _jsx("div", { className: styles.contentArea, children: _jsx("div", { className: styles.main, children: _jsx(AuthRequired, { permissions: ADMIN_PERMISSIONS, children: _jsx(LoginActivityMonitor, { LogoutModal: LogoutModal, children: _jsx(Outlet, {}, location.pathname) }) }) }) })] }) }));
};
